// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import es from './locales/es.json'
import hi from './locales/hi.json'
import { DEFAULT_LANGUAGE_CODE } from './config'

const stored = sessionStorage.getItem('qh_lang') ?? DEFAULT_LANGUAGE_CODE

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      hi: { translation: hi },
    },
    lng: stored,
    fallbackLng: DEFAULT_LANGUAGE_CODE,
    interpolation: { escapeValue: false },
  })

export default i18n
